import { tLessonPhrases } from 'common/modules/ReactShared';
import { useEffect } from 'react';

type tUseWordGamesTaskSkipEmptyPhrasesEffectArgs = {
  lessonPhrases: tLessonPhrases;
  onSkip: () => void;
};

const useWordGamesTaskSkipEmptyPhrasesEffect = (
  args: tUseWordGamesTaskSkipEmptyPhrasesEffectArgs
): void => {
  const { lessonPhrases, onSkip } = args;

  useEffect(() => {
    if (lessonPhrases && !lessonPhrases.length) onSkip?.();
  }, [lessonPhrases, onSkip]);
};

export { useWordGamesTaskSkipEmptyPhrasesEffect };
export type { tUseWordGamesTaskSkipEmptyPhrasesEffectArgs };
